import { Flex, Table, Typography } from 'antd';
import { MoneyInput } from '@/shared/ui/inputs';
import type { AllocationRow } from './model';

/** §7: сетка разнесения платежа/кассового ордера по документам — переиспользуется `PaymentWindow`
 * (оплата/возврат/обе стороны взаимозачёта) и `CashOrderWindow` (ПКО/РКО). */
export function AllocationGrid({
  title,
  remainderTitle = 'Долг',
  emptyText = 'Нет неоплаченных документов',
  rows,
  onChange,
}: {
  title: string;
  remainderTitle?: string;
  emptyText?: string;
  rows: AllocationRow[];
  onChange: (rows: AllocationRow[]) => void;
}) {
  return (
    <Flex vertical gap={4}>
      <Typography.Text style={{ fontSize: 12 }} strong>
        {title}
      </Typography.Text>
      <Table<AllocationRow>
        size="small"
        rowKey="documentId"
        dataSource={rows}
        pagination={false}
        locale={{ emptyText }}
        columns={[
          { title: 'Документ', dataIndex: 'label', width: 120 },
          { title: remainderTitle, dataIndex: 'debt', width: 90, align: 'right' },
          {
            title: 'Сумма',
            dataIndex: 'amount',
            width: 110,
            align: 'right',
            render: (_v, row) => (
              <MoneyInput
                value={row.amount}
                onChange={(v) => onChange(rows.map((r) => (r.documentId === row.documentId ? { ...r, amount: v } : r)))}
              />
            ),
          },
        ]}
      />
    </Flex>
  );
}
